// The one Supabase client of the app. Reads api_v1 only (architecture §3.3). Never holds the service key.
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { createClient, type SupportedStorage } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabaseConfigured = Boolean(url && anonKey);

// In the APK the session lives in the app's private preferences, which Android keeps across restarts and
// WebView storage clean-ups (ADR-091); the browser keeps the default localStorage.
const nativeStorage: SupportedStorage = {
  getItem: async (key) => (await Preferences.get({ key })).value,
  setItem: (key, value) => Preferences.set({ key, value }),
  removeItem: (key) => Preferences.remove({ key }),
};

export const supabase = createClient(url ?? 'http://127.0.0.1:55321', anonKey ?? 'missing-anon-key', {
  db: { schema: 'api_v1' },
  auth: Capacitor.isNativePlatform()
    ? { persistSession: true, autoRefreshToken: true, storage: nativeStorage }
    : { persistSession: true, autoRefreshToken: true },
});

export const functionsUrl = `${url ?? 'http://127.0.0.1:55321'}/functions/v1`;
